var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgFolderFavorite = function SvgFolderFavorite(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 17.336 13.865",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "#414a5f",
    "data-name": "folderFavorite"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.358 12.265H1.413A1.43 1.43 0 0 1 0 10.838v-9.41A1.43 1.43 0 0 1 1.413 0h5.233a.2.2 0 0 1 .152.07l1.3 1.539h6.493a1.43 1.43 0 0 1 1.413 1.427v3.58l-1.2-.174a.4.4 0 0 1-.3-.22l-1.1-2.135a1.3 1.3 0 0 0-1.079-.547 1.33 1.33 0 0 0-1.047.547l-1.151 2.135a.4.4 0 0 1-.3.22l-2.093.332a1.44 1.44 0 0 0-1.079 1.015 1.6 1.6 0 0 0 .422 1.391l1.4 1.425a.4.4 0 0 1 .116.357l-.223 1.3Z",
    "data-name": "folder"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.118 8.597a.721.721 0 0 0-.4-1.23l-2.435-.353a.32.32 0 0 1-.24-.174l-1.087-2.206a.721.721 0 0 0-1.293 0L10.574 6.84a.32.32 0 0 1-.24.174L7.9 7.368a.721.721 0 0 0-.4 1.23l1.762 1.717a.32.32 0 0 1 .092.282l-.416 2.424a.7.7 0 0 0 .157.585.73.73 0 0 0 .888.179l2.178-1.149a.33.33 0 0 1 .3 0l2.174 1.149a.7.7 0 0 0 .335.084.72.72 0 0 0 .553-.259.7.7 0 0 0 .16-.589l-.418-2.425a.32.32 0 0 1 .092-.282Z"
  }))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgFolderFavorite);
export default ForwardRef;